import redirectSource from './AvatarRedirect';
export default redirectSource('instagram', 'instagramId');